export type SiteMode = 'desktop' | 'mobile';

export interface NavigatorLike {
  userAgent: string;
  userAgentData?: {
    mobile?: boolean;
  };
}

const MOBILE_UA_PATTERN = /Mobi|Mobile Safari|IEMobile|Opera Mini/i;

/**
 * Detect the mode explicitly declared by the browser. Screen size, touch
 * support and platform are intentionally ignored so browser "desktop site"
 * mode remains authoritative.
 */
export function detectSiteMode(navigatorLike: NavigatorLike): SiteMode {
  const clientHint = navigatorLike.userAgentData?.mobile;
  if (typeof clientHint === 'boolean') {
    return clientHint ? 'mobile' : 'desktop';
  }
  return MOBILE_UA_PATTERN.test(navigatorLike.userAgent) ? 'mobile' : 'desktop';
}

export function siteForHost(hostname: string, port: string): SiteMode | null {
  const normalizedHost = hostname.toLowerCase();
  if (normalizedHost === 'www.yingwujiankang.com') {
    return 'desktop';
  }
  if (normalizedHost === 'm.yingwujiankang.com') {
    return 'mobile';
  }
  if (normalizedHost === 'localhost' || normalizedHost === '127.0.0.1') {
    if (port === '3000') {
      return 'desktop';
    }
    if (port === '3001') {
      return 'mobile';
    }
  }
  return null;
}

export function targetOrigin(
  targetSite: SiteMode,
  locationLike: Pick<Location, 'protocol' | 'hostname'>,
): string {
  const isLocal =
    locationLike.hostname === 'localhost' || locationLike.hostname === '127.0.0.1';
  if (isLocal) {
    return `${locationLike.protocol}//${locationLike.hostname}:${targetSite === 'desktop' ? '3000' : '3001'}`;
  }
  return targetSite === 'desktop'
    ? 'https://www.yingwujiankang.com'
    : 'https://m.yingwujiankang.com';
}
